import { ColoursObj, Icon, useValidatorContext } from "@eventr/common-storybook";
import { routes } from "routing";
import { useEditSectionContext } from "../../feat/editItinerary/editSectionProvider";
import { useGlobalRouter } from "../../feat/globalRouter/useGlobalRouter";

interface ISubItemEditButton {
  data: any;
  renderOptions: any;
}

export const SubItemEditButton = ({ data, renderOptions }: ISubItemEditButton) => {
  const { section } = useEditSectionContext();
  const { isPathValid } = useValidatorContext();
  const { pushPath } = useGlobalRouter();

  return (
    <Icon
      name="Chevron_Right"
      iconColour={isPathValid(data._id) ? undefined : ColoursObj.shades.shade3}
      onClick={() => {
        if (!isPathValid(data._id)) return;
        pushPath(
          routes.edit.sectionItemPage.build({ sectionId: section!.id, itemId: data._id, pageId: renderOptions.pageId }),
        );
      }}
    />
  );
};
